/**
 * transpositionError
 * @param {string} string1
 * @param {string} string2
 * @returns {number}
 */
export default (string1, string2) => {
	const unmatchedCharacters = [];
	if (string1 === string2 || string1.length !== string2.length) {
		// Check if both strings are of equal length or not, if not return false.
		return false;
	}
	// Compare both strings
	for (let i = 0; i < string1.length; i++) {
		if (string1[i] !== string2[i]) {
			// Count number of unmatched characters
			unmatchedCharacters.push(i);
		}
		if (unmatchedCharacters.length > 2) {
			// If unmatched characters are more than 2 then return false
			return false;
		}
	}
	// Check if on swapping any of these two characters in any string would make the string equal or not. Check if these two characters are next to each other.
	if (string1[unmatchedCharacters[0]] === string2[unmatchedCharacters[1]] && unmatchedCharacters[1] - unmatchedCharacters[0] === 1) {
		return true;
	} else {
		return false;
	}
};
